import { sharedService } from "@/modules/shared/store/services/shared-service";
import { RECEIVE_GET_TIME_ZONES } from "@/redux/constants/parameters";

const getTimeZones = sharedService.injectEndpoints({
  endpoints: builder => ({
    getTimeZones: builder.query({
      query: () => "parameters/time-zones",
      transformResponse: response => response.items,
      providesTags: ["TimeZones"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch({ type: RECEIVE_GET_TIME_ZONES, timeZones: data });
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetTimeZonesQuery } = getTimeZones;

